import { useSession } from '@/auth/useSession';
import { Tooltip } from '@/components/tooltip';
import { Checkbox } from '@/components/ui/checkbox';
import { getAdminSessions, updateSessionPeople } from '@/lib/api-calls';
import { AdminSession } from '@airreading/common/data';
import { useMutation, useQueryClient } from '@tanstack/react-query';

type CheckboxUpdateSupportAdmin = AdminSession;

export const CheckboxUpdateSupportAdmin = (props: CheckboxUpdateSupportAdmin) => {
  const {
    id,
    supportAdmin,
    students,
    coachId,
    substituteCoachId,
    coachSessionRemarks,
    coachSessionRemarksV2,
    shouldDismissEndEarlyTag,
    originalTeacherIssue,
    shouldDismissLateTag,
  } = props;

  const queryClient = useQueryClient();
  const { actingUser } = useSession();
  const { mutateAsync: updateSessionPeopleMutate } = useMutation({ mutationFn: updateSessionPeople });
  const hasSupportAdmin = !!supportAdmin;

  const isActingUserCurrentSupportAdmin = hasSupportAdmin && supportAdmin.id === actingUser.id;

  const onCheckedChange = async () => {
    const data: Parameters<typeof updateSessionPeople>[0] = {
      sessionId: id,
      payload: {
        studentIds: students.map((student) => student.id),
        supportAdminId: isActingUserCurrentSupportAdmin ? undefined : actingUser.id,
        coachId: coachId ?? undefined,
        substituteCoachId: substituteCoachId ?? undefined,
        coachSessionRemarks: coachSessionRemarks ?? undefined,
        coachSessionRemarksV2: coachSessionRemarksV2 ?? undefined,
        shouldDismissEndEarlyTag: shouldDismissEndEarlyTag ?? undefined,
        shouldDismissLateTag: shouldDismissLateTag ?? undefined,
        originalTeacherIssue,
      },
    };
    await updateSessionPeopleMutate(data);
    queryClient.invalidateQueries(getAdminSessions());
  };

  return (
    <Tooltip
      trigger={
        <Checkbox checked={hasSupportAdmin} onCheckedChange={onCheckedChange} aria-label="Assign Support Admin" />
      }
    >
      {hasSupportAdmin ? (
        <span>
          Support admin is {isActingUserCurrentSupportAdmin ? 'the acting user' : supportAdmin.fullNameOrEmail}
        </span>
      ) : (
        <button onClick={onCheckedChange} aria-label="Assign support admin to yourself">
          Assign to me
        </button>
      )}
    </Tooltip>
  );
};
